// Module
var code = `<div class="row">
	<table class="table">
		<tr>
			<th>Date</th>
			<th>1</th>
			<th>2</th>
			<th>3</th>
			<th>4</th>
			<th>5</th>
			<th>6</th>
			<th>7+</th>
		</tr>
		<tr ng-repeat="day in data.slice(1, data.length)">
		    <td>{{day.Date}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_1, 'Day_1')}">{{apply(day.Day_1) | number:2}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_2, 'Day_2')}">{{apply(day.Day_2) | number:2}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_3, 'Day_3')}">{{apply(day.Day_3) | number:2}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_4, 'Day_4')}">{{apply(day.Day_4) | number:2}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_5, 'Day_5')}">{{apply(day.Day_5) | number:2}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_6, 'Day_6')}">{{apply(day.Day_6) | number:2}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_7, 'Day_7')}">{{apply(day.Day_7) | number:2}}</td>
		</tr>
	</table>
</div>`;
// Exports
module.exports = code;